
import * as d3 from "d3";
import * as tjc from "topojson-client";
import * as tjs from "topojson-specification";


const CON_CountyFipsCodeLength = 5;
const CON_StateFipsCodeLength = 2;



const CON_NoDataColor = "darkgrey";



// =====
// =====
// TYPES
// =====
// =====


// load map file
const CON_DF_CdnUrl = "https://d13m0t4ghiw3a0.cloudfront.net";
const CON_DF_TOPO = CON_DF_CdnUrl + "/vacc-counties-10m.json";
const _topoPromise:Promise<any> = d3.json(CON_DF_TOPO);


interface canvas_t {
  containerId:string;
  svgWidth:number;
  svgHeight:number;
  projection:any;
  fipsCode:string;
}

interface canvasInternal_t extends canvas_t {
  svg:any;
  g:any;
  path:any;
}


function draw(i_Canvas:canvas_t) {
  let canvas:canvasInternal_t = {
    containerId: i_Canvas.containerId
    , svgWidth: i_Canvas.svgWidth
    , svgHeight: i_Canvas.svgHeight
    , projection: i_Canvas.projection
    , fipsCode: i_Canvas.fipsCode
    , svg: null
    , g: null
    , path: null
  };
  canvas.svg = d3.select("#" + i_Canvas.containerId)
    .attr('preserveAspectRatio', 'xMinYMin meet')
    .attr('viewBox','0 0 ' + i_Canvas.svgWidth + ' ' + i_Canvas.svgHeight)
    ;
  canvas.svg.selectAll('g').remove();
  canvas.g = canvas.svg.append('g');
  canvas.path = d3.geoPath().projection(canvas.projection);

  // console.log("mapDrawing.ts :: draw :: svgWidth: " + canvas.svgWidth + " svgHeight: " + canvas.svgHeight)

  draw_Internal(canvas);
}


function draw_Internal(i_Canvas:canvasInternal_t) {
  _topoPromise.then(topo => {
    // console.log("mapDrawing.ts :: draw_Internal :: i_Canvas.fipsCode: " + i_Canvas.fipsCode);
    // console.log(topo);


  // resize
  i_Canvas.projection.scale(1).translate([0,0]);


  // what to draw?
  let mapObjects:any = null;
  let mapObject:any = null;
  if (i_Canvas.fipsCode === "00") {
    mapObjects = topo.objects.nation;
  }
  else {
    if (i_Canvas.fipsCode.length === CON_StateFipsCodeLength)
      mapObjects = topo.objects.states;
    else
      mapObjects = topo.objects.counties;
  }
  mapObject = tjc.feature(topo, mapObjects as tjs.GeometryCollection).features.filter(d => d.id === i_Canvas.fipsCode)[0];

  // mapObject = tjc.feature(topo, mapObjects as tjs.GeometryCollection).features.filter(d => {console.log(d); return d.id === i_Canvas.fipsCode;})[0];
  // console.log(tjc.feature(topo, mapObjects as tjs.GeometryCollection));
  // console.log(tjc.feature(topo, mapObjects as tjs.GeometryCollection).features);
  // console.log("===========");
  // console.log("===========");
  // console.log(i_Canvas.fipsCode);
  // console.log(mapObjects);
  // console.log(mapObject);
  // console.log("===========");
  // console.log("===========");


  let b = i_Canvas.path.bounds(mapObject);
  let s = 0.95 / Math.max((b[1][0] - b[0][0])/i_Canvas.svgWidth, (b[1][1] - b[0][1])/i_Canvas.svgHeight);
  let t = [ (i_Canvas.svgWidth - s*(b[1][0] + b[0][0]))/2, (i_Canvas.svgHeight - s*(b[1][1] + b[0][1]))/2 ];


  i_Canvas.projection.scale(s).translate(t);


  i_Canvas.g.selectAll('path').remove();
  i_Canvas.g.selectAll('path')
    .data([mapObject])
    .enter()
    .append('path')
    .attr('class','state')
    .attr('d', i_Canvas.path)
    .style('fill', () => {
      return "#6bafd6";
    });
  });
}




// ============================
// ============================

// # geo-albers-usa-territories
// A map projection including all US overseas territories.
// Original source: https://observablehq.com/@almccon/u-s-map-with-puerto-rico-us-virgin-islands-american-samoa-gua
// An extension of https://observablehq.com/@d3/u-s-map-with-puerto-rico
// Which in turn was derived from https://github.com/d3/d3-geo/blob/master/src/projection/albersUsa.js
// ![US Albers w/ Territories map projection screenshot](https://github.com/stamen/us-albers-territories/raw/master/us-albers-territories-screenshot.png)


// MIT License
// 
// Copyright (c) 2020 Stamen Design
// 
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
// 
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
// 
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.



function geoAlbersUsaTerritories() {
   var cache:d3.GeoStream = null,
    cacheStream:d3.GeoStream = null,
    lower48 = d3.geoAlbers(),
    lower48Point:any,
    alaska = d3.geoConicEqualArea()
      .rotate([154, 0])
      .center([-2, 58.5])
      .parallels([55, 65]),
    alaskaPoint:any,
    hawaii = d3.geoConicEqualArea()
      .rotate([157, 0])
      .center([-3, 19.9])
      .parallels([8, 18]),
    hawaiiPoint:any,
    puertoRico = d3.geoConicEqualArea()
      .rotate([66, 0])
      .center([0, 18])
      .parallels([8, 18]),
    puertoRicoPoint:any,
    guamMariana = d3.geoConicEqualArea()
      .rotate([-145, 0])
      .center([0, 16])
      .parallels([10, 20]),
    guamMarianaPoint:any,
    americanSamoa = d3.geoConicEqualArea()
      .rotate([170, 0])
      .center([0, -14])
      .parallels([-14, 0]),
    americanSamoaPoint:any,
    point:Array<number>,
    pointStream:any = { // stream that only implements the point function???
      point: function (x:number, y:number) {
        point = [x, y];
      },
    };


  function multiplex(streams:Array<d3.GeoStream>):d3.GeoStream {
    return {
      point(x:number, y:number) {
        for (const s of streams) s.point(x, y);
      },
      sphere() {
        for (const s of streams) s.sphere();
      },
      lineStart() {
        for (const s of streams) s.lineStart();
      },
      lineEnd() {
        for (const s of streams) s.lineEnd();
      },
      polygonStart() {
        for (const s of streams) s.polygonStart();
      },
      polygonEnd() {
        for (const s of streams) s.polygonEnd();
      },
    };
  }


  function albersUsaTerritories(coordinates: [number,number]) {
    var x = coordinates[0],
      y = coordinates[1];
    return (
      (point = null),
      (lower48Point.point(x, y), point) ||
        (alaskaPoint.point(x, y), point) ||
        (hawaiiPoint.point(x, y), point) ||
        (puertoRicoPoint.point(x, y), point) ||
        (guamMarianaPoint.point(x, y), point) ||
        (americanSamoaPoint.point(x, y), point)
    );
  }

  albersUsaTerritories.invert = function (coordinates: [number,number]) {
    var k = lower48.scale(),
      t = lower48.translate(),
      x = (coordinates[0] - t[0]) / k,
      y = (coordinates[1] - t[1]) / k;
    return (y >= 0.12 && y < 0.234 && x >= -0.225 && x < -0.185
      ? alaska
      : y >= 0.166 && y < 0.234 && x >= -0.185 && x < -0.08
      ? hawaii
      : y >= 0.204 && y < 0.234 && x >= 0.3 && x < 0.38
      ? puertoRico
      : y >= 0.05 && y < 0.204 && x >= -0.415 && x < -0.225
      ? guamMariana
      : y >= 0.18 && y < 0.234 && x >= -0.415 && x < -0.225
      ? americanSamoa
      : lower48
    ).invert(coordinates);
  };

  albersUsaTerritories.stream = function (stream:d3.GeoStream) {
    return cache && cacheStream === stream
      ? cache
      : (cache = multiplex([
          lower48.stream((cacheStream = stream)),
          alaska.stream(stream),
          hawaii.stream(stream),
          puertoRico.stream(stream),
          guamMariana.stream(stream),
          americanSamoa.stream(stream),
        ]));
  };

  albersUsaTerritories.precision = function (_:any) {
    if (!arguments.length) return lower48.precision();
    lower48.precision(_);
    alaska.precision(_);
    hawaii.precision(_);
    puertoRico.precision(_);
    guamMariana.precision(_);
    americanSamoa.precision(_);
    return reset();
  };

  albersUsaTerritories.scale = function (_:any) {
    if (!arguments.length) return lower48.scale();
    lower48.scale(_);
    alaska.scale(_ * 0.35);
    hawaii.scale(_);
    puertoRico.scale(_ * 1.5);
    guamMariana.scale(_ * 2.0);
    americanSamoa.scale(_ * 2.0);
    return albersUsaTerritories.translate(lower48.translate());
  };

  albersUsaTerritories.translate = function (_:any) {
    const CON_Epsilon = 0.000001;


    if (!arguments.length) return lower48.translate();
    var k = lower48.scale(),
      x = +_[0],
      y = +_[1];

    lower48Point = lower48
      .translate(_)
      .clipExtent([
        [x - 0.455 * k, y - 0.238 * k],
        [x + 0.455 * k, y + 0.238 * k],
      ])
      .stream(pointStream);

    alaskaPoint = alaska
      .translate([x - 0.245 * k, y + 0.201 * k])
      .clipExtent([
        [x - 0.395 * k + CON_Epsilon, y + 0.12 * k + CON_Epsilon],
        [x - 0.155 * k - CON_Epsilon, y + 0.234 * k - CON_Epsilon],
      ])
      .stream(pointStream);

    hawaiiPoint = hawaii
      .translate([x - 0.15 * k, y + 0.212 * k])
      .clipExtent([
        [x - 0.155 * k + CON_Epsilon, y + 0.166 * k + CON_Epsilon],
        [x - 0.05 * k - CON_Epsilon, y + 0.234 * k - CON_Epsilon],
      ])
      .stream(pointStream);

    puertoRicoPoint = puertoRico
      .translate([x + 0.335 * k, y + 0.224 * k])
      .clipExtent([
        [x + 0.27 * k, y + 0.204 * k],
        [x + 0.38 * k, y + 0.234 * k],
      ])
      .stream(pointStream);

    guamMarianaPoint = guamMariana
      .translate([x - 0.415 * k, y + 0.10 * k])
      .clipExtent([
        [x - 0.45 * k, y + 0.01 * k],
        [x - 0.39 * k, y + 0.21 * k],
      ])
      .stream(pointStream);

    americanSamoaPoint = americanSamoa
      .translate([x - 0.415 * k, y + 0.215 * k])
      .clipExtent([
        [x - 0.45 * k, y + 0.21 * k],
        [x - 0.39 * k, y + 0.234 * k],
      ])
      .stream(pointStream);
    return reset();
  };

  function reset() {
    cache = cacheStream = null;
    return albersUsaTerritories;
  }

  return albersUsaTerritories.scale(1070);
}



export {
  canvas_t
  , draw
  , geoAlbersUsaTerritories
};
